import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Box, 
  Typography 
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Language as LanguageIcon } from '@mui/icons-material';

const LanguageSelector = ({ variant = 'standard', showLabel = true, sx = {} }) => {
  const { i18n, t } = useTranslation();

  const languages = [
    { code: 'en', name: t('common.english'), flag: '🇺🇸' },
    { code: 'hi', name: t('common.hindi'), flag: '🇮🇳' },
    { code: 'te', name: t('common.telugu'), flag: '🇮🇳' },
    { code: 'ta', name: t('common.tamil'), flag: '🇮🇳' },
    { code: 'kn', name: t('common.kannada'), flag: '🇮🇳' }
  ];

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
  };

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  return (
    <FormControl variant={variant} sx={{ minWidth: 120, ...sx }}>
      {showLabel && (
        <InputLabel id="language-select-label">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LanguageIcon fontSize="small" />
            {t('common.language')}
          </Box>
        </InputLabel>
      )}
      <Select
        labelId="language-select-label"
        id="language-select"
        value={i18n.language}
        onChange={handleLanguageChange}
        label={showLabel ? t('common.language') : ''}
        renderValue={(selected) => {
          const lang = languages.find(l => l.code === selected);
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <span>{lang?.flag}</span>
              <Typography variant="body2">{lang?.name}</Typography>
            </Box>
          );
        }}
      >
        {languages.map((language) => (
          <MenuItem key={language.code} value={language.code}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
              <span>{language.flag}</span>
              <Typography variant="body2">{language.name}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelector;